export default async function uncompleteTask ({ dispatch }, taskId) {
  return dispatch('updateTask', {
    id: taskId,
    completedOn: null
  })
}
